export const quickAnswer =
  '如果任务没有明确告诉你下一步去哪，先查这里。页面重点处理任务依赖、目标顺序和最容易卡住的步骤，而不是复述全部剧情。';

## 怎么找当前卡点

查看日志中的当前目标，再跳转到对应任务。不要因为装置已经就位，就默认激活或供电条件全部完成。

## Power Lines 与 Into the Sinkhole

前者重点核对车站与平台校准，后者重点核对四个中继装置和逃离路线。攻略列出步骤与常见卡点，便于逐项排查。

## 战斗困难时

另外检查[Build Power（配装整体强度）](/guides/build-power)与[技能搭配](/build-planner)，区分成长不足和任务机关未完成。
